import { TReduxActions } from '../../types/redux';
import { IExperiment } from '../../types/experiments';

const defaultState: IExperiment[] = [];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function experimentsReducer(state: IExperiment[] = defaultState, action: TReduxActions): IExperiment[] {
  return state;
}
